import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DocumentResolved } from './../../beans/health-record/other-documents.bean';
import { S3Service } from '../health-record/other-documents/s3.service';

@Injectable({
	providedIn: 'root',
})
export class AdditionalDocumentsResolver implements Resolve<DocumentResolved> {
	constructor(private s3Service: S3Service) {}

	resolve(): Observable<DocumentResolved> {
		this.s3Service.initialize();

		return this.s3Service.listObjects().pipe(
			catchError(error => {
				const message = `Additional Documents retrieval error: ${error}`;
				console.error(`[${AdditionalDocumentsResolver.name}][${this.resolve.name}]`, message);
				return of({ document: null, error: message });
			})
		);
	}
}
